import type { EventStatus } from "@mma/shared";

export const EVENT_STATUS_LABELS: Record<EventStatus, string> = {
  draft: "Kladde",
  active: "Aktiv",
  finished: "Afsluttet",
  archived: "Arkiveret",
};

const STYLES: Record<EventStatus, string> = {
  draft: "bg-neutral-800 text-neutral-400",
  active: "bg-amber-600 text-white",
  finished: "bg-emerald-900 text-emerald-200",
  archived: "bg-neutral-900 text-neutral-500",
};

export function EventStatusBadge({ status }: { status: EventStatus }) {
  return (
    <span
      className={`text-xs uppercase px-2 py-0.5 rounded ${STYLES[status] ?? STYLES.draft}`}
    >
      {EVENT_STATUS_LABELS[status] ?? status}
    </span>
  );
}
